import * as O from 'fp-ts/Option';
export var fromEmpty = function fromEmpty(str) {
  return typeof str === 'string' && str.length > 0 ? O.some(str) : O.none;
};